import { useEffect, useState } from 'react';
import Head from './Head';
import { useFormik } from 'formik';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import CompleteSignup from '../CompleteSignup';
import { signUpAgent, signUpRealestate } from '@services/Api';
import { getCookie, setCookie, validateNationalID } from '@helper/functions';
import ToastError from '../../toast/ToastError';
import ToastSuccess from '../../toast/ToastSuccess';

export default function SignupRealestate() {
  const [signUp, setSignUp] = useState(false);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(null); // Store the cookie value in state

  useEffect(() => {
    const fetchCookie = async () => {
      const cookieId = await getCookie('id');
      setId(cookieId);
    };
    fetchCookie();
  }, []);

  const formikSignUpRealestate = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      nationalID: '',
      statusBusinessLicense: '',
      nameAgency: '',
      telAgency: '',
      tradeID: '',
      logo: '',
      province: '',
      city: '',
      address: '',
      Coordinate: '',
    },
    validate: (values) => {
      const errors = {};
      const phoneRegExp = /^0[1-9]\d{1,2}-?\d{7,8}$/;
      const nationalIDRegExp = /^\d{10}$|^[\u06F0-\u06F9]{10}$/;
      if (!values.firstName.trim()) {
        errors.firstName = 'نام را وارد کنید';
      }
      if (!values.lastName.trim()) {
        errors.lastName = 'نام خانوادگی را وارد کنید';
      }
      if (!values.nationalID) {
        errors.nationalID = 'کد ملی را وارد کنید';
      } else if (!validateNationalID(values.nationalID)) {
        errors.nationalID = 'لطفا یک کد ملی معتبر وارد کنید';
      }
      if (!values.statusBusinessLicense && step > 1) {
        errors.statusBusinessLicense = 'وضعیت پروانه کسب را انتخاب کنید';
      }
      if (!values.nameAgency.trim() && step > 1) {
        errors.nameAgency = 'نام آژانس را وارد کنید';
      }
      if (!values.telAgency && step > 1) {
        errors.telAgency = 'تلفن ثابت آژانس را وارد کنید';
      } else if (!phoneRegExp.test(values.telAgency) && step > 1) {
        errors.telAgency = 'لطفا یک شماره تلفن معتبر وارد کنید';
      }
      // if (!values.tradeID && step > 1) {
      //   errors.tradeID = "شناسه صنفی را وارد کنید";
      // } else if (values.tradeID.length != 10 && step > 1) {
      //   errors.tradeID = "لطفا یک شناسه صنفی معتبر وارد کنید";
      // }
      // if (!values.logo && step > 1) {
      //   errors.logo = "لوگو را آپلود کنید";
      // }
      if (!values.province && step > 2) {
        errors.province = 'استان را وارد کنید';
      }
      if (!values.city && step > 2) {
        errors.city = 'شهر را وارد کنید';
      }
      if (!values.address.trim() && step > 2) {
        errors.address = 'آدرس را وارد کنید';
      }
      if (!values.Coordinate && step > 2) {
        errors.Coordinate = 'لوکیشن را انتخاب کنید';
      }

      return errors;
    },
    onSubmit: async (values) => {
      if (step === 1) {
        formikSignUpRealestate.setFieldTouched('firstName', true);
        formikSignUpRealestate.setFieldTouched('lastName', true);
        formikSignUpRealestate.setFieldTouched('nationalID', true);
        formikSignUpRealestate.setFieldTouched('statusBusinessLicense', false);
        formikSignUpRealestate.setFieldTouched('nameAgency', false);
        formikSignUpRealestate.setFieldTouched('telAgency', false);
        formikSignUpRealestate.setFieldTouched('tradeID', false);
        formikSignUpRealestate.setFieldTouched('province', false);
        formikSignUpRealestate.setFieldTouched('city', false);
        formikSignUpRealestate.setFieldTouched('address', false);
        formikSignUpRealestate.setFieldTouched('Coordinate', false);
      } else if (step === 2) {
        formikSignUpRealestate.setFieldTouched('statusBusinessLicense', true);
        formikSignUpRealestate.setFieldTouched('nameAgency', true);
        formikSignUpRealestate.setFieldTouched('telAgency', true);
        formikSignUpRealestate.setFieldTouched('tradeID', true);
        formikSignUpRealestate.setFieldTouched('province', false);
        formikSignUpRealestate.setFieldTouched('city', false);
        formikSignUpRealestate.setFieldTouched('address', false);
        formikSignUpRealestate.setFieldTouched('Coordinate', false);
      } else if (step === 3) {
        formikSignUpRealestate.setFieldTouched('address', true);
        formikSignUpRealestate.setFieldTouched('province', true);
        formikSignUpRealestate.setFieldTouched('city', true);
      }
      setStep((prev) => (prev < 3 ? prev + 1 : prev));
      const formDataGenerator = () => {
        const formData = new FormData();
        formData.append('name', formikSignUpRealestate.values.nameAgency.trim());
        formData.append('buisinessLicense', formikSignUpRealestate.values.statusBusinessLicense);
        formData.append('phoneNumber', formikSignUpRealestate.values.telAgency);
        formData.append('tradeId', formikSignUpRealestate.values.tradeID);
        formData.append('coordinate', formikSignUpRealestate.values.Coordinate.lat.toString());
        formData.append('coordinate', formikSignUpRealestate.values.Coordinate.lng.toString());
        formData.append('address', formikSignUpRealestate.values.address.trim());
        formData.append('city', formikSignUpRealestate.values.city);

        if (formikSignUpRealestate.values.logo instanceof File) {
          formData.append('profile', formikSignUpRealestate.values.logo, formikSignUpRealestate.values.logo.name);
        } else {
        }

        return formData;
      };

      if (step === 3) {
        try {
          setLoading(true);

          const dataAgent = {
            fullname:
              formikSignUpRealestate.values.firstName.trim() + ' ' + formikSignUpRealestate.values.lastName.trim(),
            userType: 'realStateOwner',
            nationalId: formikSignUpRealestate.values.nationalID,
          };

          // اجرای تابع signUpAgent و منتظر ماندن برای نتیجه
          const resAgent = await signUpAgent(dataAgent, id);
          if (resAgent.status === 'success') {
            setCookie('accessToken', resAgent.data.accessToken, 1);
            setCookie('refreshToken', resAgent.data.refreshToken, 14);
            ToastSuccess({ content: 'ثبت نام مشاور با موفقیت انجام شد' });

            // اجرای تابع signUpRealestate پس از موفقیت signUpAgent
            const resRealestate = await signUpRealestate(formDataGenerator(), id);
            if (resRealestate.status === 'success') {
              ToastSuccess({ content: 'ثبت نام املاک با موفقیت انجام شد' });
              setStep(4);
            } else {
              ToastError({
                content: 'مشکلی در ثبت نام املاک پیش آمده، مجددا تلاش کنید',
              });
            }
          } else {
            ToastError({
              content: 'مشکلی در ثبت نام مشاور پیش آمده، مجددا تلاش کنید',
            });
          }
        } catch (e) {
          ToastError({ content: 'مشکلی پیش آمده، مجددا تلاش کنید' });
        } finally {
          setLoading(false);
        }
      }
    },
  });

  const handleSubmitAttempt = (e) => {
    e.preventDefault();

    // Manually mark fields as touched based on the step
    if (step === 1) {
      formikSignUpRealestate.setFieldTouched('firstName', true);
      formikSignUpRealestate.setFieldTouched('lastName', true);
      formikSignUpRealestate.setFieldTouched('nationalID', true);
    } else if (step === 2) {
      formikSignUpRealestate.setFieldTouched('statusBusinessLicense', true);
      formikSignUpRealestate.setFieldTouched('nameAgency', true);
      formikSignUpRealestate.setFieldTouched('telAgency', true);
      formikSignUpRealestate.setFieldTouched('tradeID', true);
    } else if (step === 3) {
      formikSignUpRealestate.setFieldTouched('province', true);
      formikSignUpRealestate.setFieldTouched('city', true);
      formikSignUpRealestate.setFieldTouched('address', true);
    }

    // Trigger validation
    formikSignUpRealestate.validateForm().then((errors) => {
      if (Object.keys(errors).length === 0) {
        formikSignUpRealestate.handleSubmit(e); // Only submit if no errors
      }
    });
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <Step1
            formikSignUpRealestate={formikSignUpRealestate}
            handleSubmitAttempt={handleSubmitAttempt}
            setStep={setStep}
          />
        );
      case 2:
        return (
          <Step2
            formikSignUpRealestate={formikSignUpRealestate}
            handleSubmitAttempt={handleSubmitAttempt}
            setStep={setStep}
          />
        );
      case 3:
        return (
          <Step3
            formikSignUpRealestate={formikSignUpRealestate}
            handleSubmitAttempt={handleSubmitAttempt}
            setStep={setStep}
            loading={loading}
          />
        );
      case 4:
        return <CompleteSignup role="مدیر" />;

      default:
        return <Step1 formikSignUpRealestate={formikSignUpRealestate} />;
    }
  };
  return (
    <div className="flex flex-col w-full h-full items-center justify-start gap-4 md:gap-8">
      {/* <h3 className="text-xl md:text-2xl 2xl:text-3xl font-bold whitespace-nowrap">
        برای ثبت نام اطلاعات زیر را تکمیل نمایید .
      </h3> */}
      <Head step={step} />
      {renderStep()}
    </div>
  );
}
